export default __webpack_public_path__ + "static/media/stepper-three.01a37d20.png";